<template lang="pug">

	section#projectsApp.container.contained
		template(v-if="isFiltered")
			.filter-display
				.component.full(type="page-header")
					h1 Showing projects 
						span(v-if="niceFilters.categories.length") from 
						span(v-if="niceFilters.categories.length" v-for="(category, index) in niceFilters.categories") 
							span.border-b-2 {{ category }}
							span(v-if="index < niceFilters.categories.length - 1") , 
						span(v-if="niceFilters.locations.length") located in 
						span(v-if="niceFilters.locations.length" v-for="(location, index) in niceFilters.locations") 
							span.border-b-2 {{ location }}
							span(v-if="index < niceFilters.locations.length - 1") , 

				p.flex.justify-end.whitespace-nowrap.pl-8.cursor-pointer(@click="clearFilter()" class="hover:text-orange") Clear filters
		template(v-else)
			.component.full(type="page-header")
				h1 All Projects
		.entries-grid-wrapper.project-grid-wrapper
			.entries-grid
				template(v-for="(project, index) in filteredProjects")
					a.entry-tile(
						:href="project.url"
						:class="{ 'featured' : index > 0 && (index) % projects.showFeaturedEvery === 0 }"
						)
						.entry-tile-image
							img(width="600" height="420" v-if="project.hero_image" :src="'img' + project.hero_image.url + '?w=600&h=420&fit=crop'" :alt="project.title")
							img(v-else :src="'img/img/no-image.png?w=600&h=420&fit=crop'" :alt="project.title")
						.entry-details.project-details
							p {{ project.title }}
							p {{ project.location }}

					//- template(v-if="index > 0 && (index + 1) % showFeaturedEvery === 0")
					//- 	div.col-span-4.grid.grid-cols-4.gap-4.border-b.border-t.py-8 {{ project.title }}

			.no-results(v-if="filteredProjects.length === 0")
				h1.text-2xl No results found
				p.text-base.underline.cursor-pointer(@click="clearFilter()" class="hover:text-orange") Clear filters

		.filter-bar(
			v-if="!loading"
			:class="{ 'active' : filter.active }" 
			@click="filter.active = !filter.active"
		) Filter

		#filterModal(:class="{ 'active' : filter.active }")
			.filter-closer(@click="filter.active = !filter.active")
				include ../../../pug/partials/icon-close.pug

			.filter-container
				.filter-title.text-base.pb-2 Category
				.filter-options.mb-4
					template(v-for="(category, index) in categories")
						.filter-link(@click="toggleFilter('categories', category.slug)" :class="{ 'selected' : category.selected }") 
							span.filter-link-title {{ category.title }}
							span(v-if="index < categories.length - 1") ,&nbsp;

				.filter-title.text-base.pb-2 Location
				.filter-options.mb-4
					template(v-for="(location, index) in locations")
						.filter-link(@click="toggleFilter('locations', location.slug)" :class="{ 'selected' : location.selected }") 
							span.filter-link-title {{ location.title }}
							span(v-if="index < locations.length - 1") ,&nbsp;

				.filter-title.text-base Sort
				.filter-options
					.filter-link(v-if="sort.recent" class="selected")
						span.filter-link-title Recent
					.filter-link(v-else @click="sortBy('recent')") 
						span.filter-link-title Recent
					span , 
					.filter-link(v-if="sort.name" class="selected") 
						span.filter-link-title Name
					.filter-link(v-else @click="sortBy('name')") 
						span.filter-link-title Name

				.filter-clear(@click="clearFilter()" :class="{ 'active' : isFiltered }") Clear Filters

		.filter-overlay(:class="{' active ': filter.active }" @click="filter.active = !filter.active")
		.filter-loading(:class="{' active ': loading }")
			i.fal.fa-spinner.fa-spin.text-2xl
			.errors(v-if="errors")
				span.p-4(v-for="error in errors") {{ error.message }}

						
</template>

<script>
const axios = require('axios');
import ProjectsQuery from '../graphql/projects.graphql';
import { print } from 'graphql/language/printer';
let ProjectsQueryString = print(ProjectsQuery);

export default {
	el: "projects",
	name: "Projects",
	data() {
		return {
			loading: true,
			projects: {
				all: [],
				featured: [],
				showFeaturedEvery: 8,
			},
			categories: [],
			locations: [],
			filter: {
				active: false,
				categories: [],
				locations: [],
			},
			sort: {
				recent: true,
				name: false
			},
			errors: false
		}
	},
	methods: {
		getProjects() {
			return axios({
				url: '/graphql',
				method: 'post',
				data: {
					query: ProjectsQueryString
				}
			})
		},
		toggleFilter(taxonomy, slug) {

			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});

			if (taxonomy === 'categories') {
				this.filter.locations = []
				this.locations.forEach(location => {
					location.selected = false
				})
				let category = this.categories.find(category => category.slug === slug)
				if (category.selected === true) {
					category.selected = false
					this.filter.categories = this.filter.categories.filter(category => category !== slug)
				} else {
					this.filter.categories.push(slug)
					category.selected = true
				}
			} else if (taxonomy === 'locations') {
				this.filter.categories = []
				this.categories.forEach(category => {
					category.selected = false
				})
				let location = this.locations.find(location => location.slug === slug)
				if (location.selected === true) {
					location.selected = false
					this.filter.locations = this.filter.locations.filter(location => location !== slug)
				} else {
					this.filter.locations.push(slug)
					location.selected = true
				}
			}
		},
		clearFilter() {
			this.filter.categories = []
			this.filter.locations = []
			this.categories.forEach(category => {
				category.selected = false
			})
			this.locations.forEach(location => {
				location.selected = false
			})
			this.sort.name = false
			this.sort.recent = true
		},
		sortBy(choice) {
			this.sort.recent = false
			this.sort.name = false
			switch(choice) {
				case 'recent':
					this.sort.recent = !this.sort.recent
					break;
				case 'name':
					this.sort.name = !this.sort.name
					break;
			}
		}
	},
	watch: {
		// loading: {
		// 	immediate: true,
		// 	handler() {
		// 		this.loading ? document.body.classList.add('overflow-y-hidden') : document.body.classList.remove('overflow-y-hidden')
		// 	}
		// },
		filter: {
			immediate: true,
			deep: true,
			handler(val) {
				let mainEl = document.querySelector('main')
				this.filter.active ? mainEl.classList.add('overflow-hidden') : mainEl.classList.remove('overflow-hidden')
			}
		}
	},
	computed: {
		// All projects minus featured
		// allNonFeaturedProjects() {
		// 	return this.projects.all.filter(project => {
		// 		return !this.projects.featured.includes(project.id);
		// 	});
		// },
		// featuredProjects() {
		// 	return this.projects.all.filter(project => {
		// 		return this.projects.featured.includes(project.id);
		// 	});
		// },
		isFiltered() {
			return this.filter.categories.length > 0 || this.filter.locations.length > 0
		},
		niceFilters() {
			let categories = this.categories.filter(category => category.selected === true)
			categories = categories.map(category => category.title)

			let locations = this.locations.filter(location => location.selected === true)
			locations = locations.map(location => location.title)

			return {
				categories: categories,
				locations: locations
			}
		},
		filteredProjects() {
			let res = []

			//- Filter
			if (this.filter.categories.length || this.filter.locations.length) {
				this.projects.all.forEach(project => {
					let found = false
					if (this.filter.categories.length && project.project_categories !== null) {
						project.project_categories.forEach(category => {
							if (this.filter.categories.includes(category.slug)) {
								found = true
							}
						});
					}
					if (this.filter.locations.length && project.project_locations !== null) {
						if (this.filter.locations.includes(project.project_locations.slug))
							found = true
					}
					if (found)
						res.push(project);
				});
			}
			else {
				res = this.projects.all
			}


			//- Sort

			if (this.sort.recent) {
				console.log('Sorting by recent')
				res.sort((a, b) => {
					return (Number(a.completion_year) > (Number(b.completion_year))) ? -1 : 1
				})
			}

			if (this.sort.name) {
				console.log('Sorting by name')
				res.sort((a, b) => {
					return a.title.localeCompare(b.title)
				})
			} 

			return res
		}
	},
	beforeMount() {
		this.getProjects()
			.then((response) => {
				// console.log(response)

				if (response.data.errors) {
					this.errors = response.data.errors
				}

				let projects = []
				response.data.data.projects.entries.forEach((project, index) => {
					project.original_index = index
					projects.push(project)
				})
				this.projects.all = projects

				let categories = []
				response.data.data.categories.terms.forEach(category => {
					category.selected = false
					categories.push(category)
				})
				this.categories = categories

				let locations = []
				response.data.data.locations.terms.forEach(location => {
					location.selected = false
					locations.push(location)
				})
				this.locations = locations

				let featured = []
				response.data.data.featured.featured_projects.forEach(project => {
					featured.push(project.id)
				})
				this.projects.featured = featured

				let searchParams = new URLSearchParams(document.location.search)
				let urlCategoryFilter = searchParams.get('category')
				if (urlCategoryFilter) {
					urlCategoryFilter.split(',').forEach(category => {
						this.categories.forEach(cat => {
							if (cat.slug === category) {
								this.toggleFilter('categories', category)
							}
						})
					})
				}

				let urlLocationFilter = searchParams.get('location')
				if (urlLocationFilter) {
					urlLocationFilter.split(',').forEach(location => {
						this.locations.forEach(loc => {
							if (loc.slug === location) {
								this.toggleFilter('locations', location)
							}
						})
					})
				}

				this.loading = false

			})
			.catch((error) => {
				console.log(error);
			})
			.then(() => {
				console.log('Projects loaded');
			});
	}
}
</script>
